import { render } from "./UpdateRequirementsStatusModal.vue?vue&type=template&id=7285344a&ts=true"
import script from "./UpdateRequirementsStatusModal.vue?vue&type=script&lang=ts"
export * from "./UpdateRequirementsStatusModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__